import { hasBase } from '@aytm/app/stats/page/question-views/answer-variants/components/chart/lib/chartModes'
import {
  calcDrawableChartMode,
  calcQuestionChartMode
} from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const getChartModeTypes = ({ answer, percentsOnly = false }) => {
  if (hasBase(answer) || percentsOnly) return ['percents', 'bpercents']

  return ['pie', 'respondents', 'percents', 'brespondents', 'bpercents']
}

// the type's own rules; the exported resolver then fits the result to the modes the view offers
const calcPreferredChartMode = ({ chartMode, questionChartMode, globalChartMode, answer, percentsOnly = false }) => {
  const mode = calcQuestionChartMode(chartMode, questionChartMode, globalChartMode)

  if ((hasBase(answer) || percentsOnly) && !['percents', 'bpercents'].includes(mode)) {
    return 'percents'
  }

  return mode
}

export const getDefaultChartMode = args =>
  calcDrawableChartMode(calcPreferredChartMode(args), getChartModeTypes(args), {
    globalChartMode: args.globalChartMode
  })
